import { render, staticRenderFns } from "./NewMatterPresentation.vue?vue&type=template&id=3c665d0f&scoped=true"
import script from "./NewMatterPresentation.vue?vue&type=script&lang=js"
export * from "./NewMatterPresentation.vue?vue&type=script&lang=js"
import style0 from "./NewMatterPresentation.vue?vue&type=style&index=0&id=3c665d0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c665d0f",
  null
  
)

export default component.exports